/**
 * @Author: Zero
 * @Date: 2025-11-10 09:12:16
 * @Explain: 测试玩家管理模块
 */
export default {
  // 测试人列表
  'TESTER.MANAGE.LIST.CREATE': '构建测试用户池',
  'TESTER.MANAGE.LIST.CREATE.NEW.TESTER': '新建测试玩家列表',
  'TESTER.MANAGE.LIST.COPY.LINK': '注册&邀请链接',
  'TESTER.MANAGE.LIST.COPY.LINK.PLACEHOLDER': '注册链接待配置',
  'TESTER.MANAGE.LIST.COPY.REDIRECT.PLACEHOLDER': '点击在新页面打开链接',
  'TESTER.MANAGE.LIST.COPY.LINK.TIP': '复制注册&邀请链接',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP': '配置未完成，无法复制链接',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.SUCCESS': '链接已复制',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.FAIL': '复制链接失败',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TITLE':
    '此链接可用作官网等渠道的<b>注册链接</b>，支持用户注册账号并报名参与测试。 若用于<b>邀请邮件</b>，已注册用户收到后可直接点击接受邀请。<br/><b>注意</b>： 测试链接的配置需联系 <a class="account" href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> 完成。在此之前，您可以查阅 <a class="account" href="{ url }" target="_blank">用户手册</a> 了解相关详情。',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TEXT':
    '所有受邀的测试玩家点击邀请链接后，将进入以下网页流程以完成邀请流程。该流程及样式均可定制。',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.CONTENT':
    '所有受邀的测试玩家点击邀请链接后，将进入以下网页流程以完成邀请流程。该流程及样式均可定制。',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.DESCRIPTION': '输入备注',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.NAME': '输入名称',
  'TESTER.MANAGE.CREATE.ENTER.NAME': '名称',
  'TESTER.MANAGE.CREATE.ENTER.DESCRIPTION': '备注',
  'TESTER.MANAGE.CREATE.VERIFY.NAME': '名字不能为空',
  'TESTER.MANAGE.CREATE.VERIFY.NAME.REPEAT': '当前输入的名字已存在',
  'TESTER.MANAGE.MODAL.TITLE': '新建测试玩家列表',
  'TESTER.MANAGE.EMPTY': '欢迎使用 Playtest Hub',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.MANAGE': '构建并管理测试用户池',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.INVITATION': '发送测试邀请与游戏兑换码',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.USER': '获取测试用户Discord、Steam 账号',
  'TESTER.MANAGE.EMPTY.EXAMPLE.CONFIDENTIALITY': '在线签署 NDA 保密协议',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.Discord': '将测试者自动加入 Discord社群',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.EASILY.COMPLETE':
    'SmartLink 让你轻松完成：',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.SUBTITLE':
    '集中管理你的测试玩家，打造高效、有序的游戏测试流程。',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.TIPS':
    '从招募到协作，一切尽在 SmartLink。让测试管理更高效，沟通更顺畅，体验更专业。',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION': '配置信息',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION.TAG':
    '{tagName}的联系人单向同步至列表,故标签移除不会影响此列表联系人数据',
  'TESTER.MANAGE.TESTER': '测试玩家',
  'TESTER.MANAGE.TESTER.NOT.CONFIG': '未配置',
  'TESTER.MANAGE.TESTER.INVITATION.JOURNEY': '邀请旅程',
  'TESTER.MANAGE.TESTER.SYNC': '测试玩家同步中，请稍后再试',
  'TESTER.MANAGE.TESTER.NOT.PLAYER.ADD': '当前无待邀请状态的测试玩家,请添加',
  'TESTER.MANAGE.TESTER.INVITATIONS.PROGRESS': '玩家邀请中....',
  'TESTER.MANAGE.TESTER.INVITATION.PLEASE.COMPLETE.THE': '请先激活',
  'TESTER.MANAGE.TESTER.LAST.INVITED.AT': '上次邀请是{CONTACT}在{DATE}',
  'TESTER.MANAGE.TESTER.LAST.SAVED.AT': '上次保存是{CONTACT}在{DATE}',
  'TESTER.MANAGE.TESTER.LAST.STATUS': '状态:',
  'TESTER.MANAGE.LIST.DISCORD.SENTIMENT': '情感分',
  'TESTER.MANAGE.LIST.DISCORD.SENTIMENT.TOOLTIPS':
    '基于多语种NLP情感分模型，给每1条发言或评论赋予情感分值，分为：负面(1分),中性(3分),正面(5分)。汇总情感分为各条发言或评论情感分加总求平均，分值范围为1-5。',
  'TESTER.MANAGE.LIST.CONTRIBUTION': '贡献度',
  'TESTER.MANAGE.LIST.CONTRIBUTION.TOOLTIPS':
    '贡献度 = 高价值消息数 / 总消息数。用于衡量玩家产出有效反馈的比例。',
  'TESTER.MANAGE.TESTER.LAST.NOT.INVITED': '未邀请过',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST': '待邀请',
  'TESTER.MANAGE.LIST.STATUS.INVITED': '待接受',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED': '接受邀请',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING': '接受邀请',
  'TESTER.MANAGE.LIST.STATUS.WAITING': '待邀请',
  'TESTER.MANAGE.LIST.STATUS.INVITE.LINK': '邀请链接',
  'TESTER.MANAGE.LIST.STATUS.INVITE.EMAIL': '邀请电子邮件',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING.EMAIL': '资源码邮件',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST.NOTES': '从标签新进入的联系人的初始状态',
  'TESTER.MANAGE.LIST.STATUS.INVITED.NOTES':
    '发起邀请后，联系人状态更新为已邀请。',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED.NOTES':
    '联系人完成了邀请链接中预设的流程（支持个性化设置）后，状态会更新为接受邀请。',
  'TESTER.MANAGE.LIST.STATUS.TITLE': '状态',
  // 测试人列表-按钮相关
  'TESTER.MANAGE.LIST.EDIT': '编辑',
  'TESTER.MANAGE.LIST.CONFIGURE': '配置',
  'TESTER.MANAGE.LIST.VIEW.DETAILS': '测试玩家列表',
  'TESTER.MANAGE.LIST.AI.ANALYTICS': 'AI分析',
  // 邀请旅程
  'TESTER.MANAGE.LIST.INVITATION JOURNEY': '邀请旅程',
  // 旅程状态文本
  'TESTER.MANAGE.LIST.STATUS.EDIT': '编辑',
  'TESTER.MANAGE.LIST.STATUS.SUSPEND': '暂停',
  'TESTER.MANAGE.LIST.STATUS.DETAILS': '详情',
  'TESTER.MANAGE.LIST.STATUS.REVIEWS.ERROR': '处理异常',

  // 测试管理列表
  'TESTER.MANAGE.TEST.LIST.FILTERS.MY.NO.REGION': '暂无区域',
  // 顶部筛选条件 - 添加条件菜单 & 条件标签
  'TESTER.MANAGE.TEST.LIST.FILTERS.ADD.CONDITION': '添加条件',
  'TESTER.MANAGE.TEST.LIST.FILTERS.EMAIL': '邮箱',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM': 'Steam',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY': 'Steam 兑换码',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID': 'Steam ID',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID.FILLED': '已填写',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID.NOT.FILLED': '未填写',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID.SEARCH': '搜索',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PSN.ID.HAS.VALUE': '有值',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PSN.ID.NO.VALUE': '无值',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PSN.ID.SEARCH': '搜索',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYTIME': '游戏时长',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.WISHLIST': '愿望清单',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DISCORD': 'Discord',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DISCORD.USERNAME': 'Discord 用户名',
  'TESTER.MANAGE.TEST.LIST.FILTERS.SENTIMENT': '情感分',
  'TESTER.MANAGE.TEST.LIST.FILTERS.CONTRIBUTION': '贡献度',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYER.INFO': '玩家信息',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.TITLE': '区域',
  'TESTER.MANAGE.TEST.LIST.FILTERS.LANGUAGE': '语言',
  // 按钮部分
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.ALL.TESTERS': '所有玩家：',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.SHOWING.L': '共 ',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.SHOWING.R': ' 个符合筛选条件玩家',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.CLEAR.FILTERS': '清除筛选结果',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.SELECTED': '已选择',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.CLEAR.SELECTED': '清空已选择',
  // string 型 survey 动态筛选通用选项文案
  'TESTER.MANAGE.TEST.LIST.FILTERS.STRING.HAS.VALUE': '有值',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STRING.NO.VALUE': '无值',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STRING.SEARCH': '搜索',
  'TESTER.MANAGE.TEST.LIST.FILTERS.SUBSCRIPTION.STATUS': '订阅状态',
  'TESTER.MANAGE.TEST.LIST.FILTERS.TIME.ADDED': '加入时间',
  'TESTER.MANAGE.TEST.LIST.FILTERS.TIME.INVITED': '邀请发送时间',
  'TESTER.MANAGE.TEST.LIST.FILTERS.TIME.ACCEPT': '接受邀请日期',
  'TESTER.MANAGE.TEST.LIST.FILTERS.INVITED.FRIENDS.COUNT': '邀请好友数',
  'TESTER.MANAGE.TEST.LIST.FILTERS.BAN.STATUS': '封禁',
  'TESTER.MANAGE.TEST.LIST.FILTERS.BAN.STATUS.BANNED': '已封禁',
  'TESTER.MANAGE.TEST.LIST.FILTERS.BAN.STATUS.UNBANNED': '普通用户',
  // 封禁/解封相关
  'TESTER.MANAGE.BAN.BUTTON.BANNED': '已封禁',
  'TESTER.MANAGE.BAN.BUTTON.UNBAN': '解除封禁',
  'TESTER.MANAGE.BAN.BUTTON.UNBAN.TIPS1': '单次解封最多选中一人',
  'TESTER.MANAGE.BAN.AND.UNBAN.TIPS':
    '当前存在跨页选中的联系人，系统无法确认实际选中人数，请仅在当前页选择1人后操作',
  'TESTER.MANAGE.BAN.DIALOG.TITLE': '确认封禁该测试玩家吗？',
  'TESTER.MANAGE.BAN.DIALOG.TITLE.PLURAL': '封禁测试列表玩家',
  'TESTER.MANAGE.BAN.DIALOG.CONTENT.LINE1':
    '玩家被封禁后，将无法继续完成注册或接受邀请。',
  'TESTER.MANAGE.BAN.DIALOG.CONTENT.LINE2':
    '如果该玩家已加入 Discord 频道，会同步被服务器封禁；',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.TIP':
    '<b class="color-333"><span class="color-error">{name}</span> 将被封禁</b>',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.LABEL': '输入',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.KEYWORD': 'BAN',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.SUFFIX': '以确认操作',
  // 'TESTER.MANAGE.BAN.DIALOG.SYNC.INFO':
  //   '禁用状态会同步到玩家测试中心其他测试中',
  'TESTER.MANAGE.BAN.SUCCESS': '封禁成功',
  'TESTER.MANAGE.UNBAN.DIALOG.TITLE': '确认取消封禁此玩家？',
  'TESTER.MANAGE.UNBAN.DIALOG.CONTENT.LINE1':
    '玩家被解封后，原本失效的注册或受邀链接可恢复生效，并取消服务器的封禁。',
  // 'TESTER.MANAGE.UNBAN.DIALOG.CONTENT.LINE2':
  //   '同步解除联系人在 Discord 服务器内的封禁状态。',
  'TESTER.MANAGE.UNBAN.SUCCESS': '解封成功',
  // 顶部筛选条件 - 选项与 placeholder
  'TESTER.MANAGE.TEST.LIST.FILTERS.STATUS.PLACEHOLDER': '状态',
  // 顶部标签过滤器 placeholder（参考数据看板）
  'TESTER.MANAGE.TEST.LIST.FILTERS.TAG.PLACEHOLDER': '标签',
  // 通用占位符：条件下拉框 / 级联 / 日期范围等未选中时的默认提示
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.PLACEHOLDER': '请选择',
  // Range 型条件常用的 min/max 前缀（与单位拼接，如"最少分钟"、"最多小时"）
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MIN': '最少',
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MAX': '最多',
  // 情感分 / 贡献度 使用"最低分 / 最高分"
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MIN.SCORE': '最低分',
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MAX.SCORE': '最高分',
  // 范围输入框不完整提示
  'TESTER.MANAGE.TEST.LIST.FILTERS.RANGE.INCOMPLETE.WARNING':
    '请输入完整的分数区间（需同时填写最高分与最低分）。',
  'TESTER.MANAGE.TEST.LIST.FILTERS.GAMETIME.RANGE.INCOMPLETE.WARNING':
    '请输入完整的时长范围（需同时填写最短与最长时长）。',
  'TESTER.MANAGE.TEST.LIST.FILTERS.INVITED.FRIENDS.RANGE.INCOMPLETE.WARNING':
    '请输入完整的好友数范围（需同时填写最少人数和最多人数）。',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYTIME.UNIT.MIN': '分钟',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYTIME.UNIT.HOUR': '小时',
  'TESTER.MANAGE.TEST.LIST.FILTERS.WISHLIST.AVAILABLE': '已添加',
  'TESTER.MANAGE.TEST.LIST.FILTERS.WISHLIST.NO.DATA': '未添加',
  'TESTER.MANAGE.TEST.LIST.FILTERS.WISHLIST.PRIVATE': '未公开',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SEARCH.ZONE.PLACEHOLDER': '搜索大区',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SEARCH.REGION.PLACEHOLDER':
    '搜索区域',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SELECT.TIP': '* 请选择相关选项',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SUBTITLE': '区域',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.NO.DATA': '暂无数据',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.NO.REGIONS': '暂无区域',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SELECT.ZONE.FIRST':
    '请先选择一个大区',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.START.END':
    '开始日期  -  结束日期',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.7.DAYS': '最近 7 天',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.14.DAYS': '最近 14 天',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.30.DAYS': '最近 30 天',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.90.DAYS': '最近 90 天',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.180.DAYS': '最近 180 天',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.ALL.OF.TIME': '全部时间',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY.STATUS.REDEEMED': '已兑换',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY.STATUS.UNREDEEMED': '未兑换',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY.STATUS.FETCHING': '获取中',
  'TESTER.MANAGE.TEST.LIST.REGION': '区域',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GROUP.TITLE': '区域',
  'TESTER.MANAGE.TEST.LIST.REGION.CUSTOM.AREA.GROUP.TITLE': '大区',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.L':
    '可新建大区，移动Others内区域到新建大区中。<br/>快使用',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.C': '区域管理',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.R': '更新区域的大区划分吧',
  // 编辑标题-修改信息弹窗确认按钮
  'TESTER.MANAGE.TEST.LIST.HEADER.TITLE': '保存',
  // 修改测试人列表-标题
  'TESTER.MANAGE.TEST.LIST.EDIT.TESTER.TITLE': '编辑测试玩家列表',
  'TESTER.MANAGE.TEST.LIST.TITLE': '测试玩家列表',
  'TESTER.MANAGE.TEST.LIST.TITLE.NO.TESTERS.YET': '无测试玩家',
  'TESTER.MANAGE.TEST.LIST.SEARCH.NAME.PLACEHOLDER': '搜索玩家邮箱',
  'TESTER.MANAGE.TEST.LIST.SEARCH.STATUS': 'Status',
  // 邀请按钮
  'TESTER.MANAGE.TEST.LIST.INVITE.WAITING.TESTER': '邀请待邀请玩家',
  'TESTER.MANAGE.TEST.LIST.INVITE.WAITING.TESTER.NUM': '（{num}）',
  // 删除相关的按钮
  'TESTER.MANAGE.TEST.LIST.REMOVE.CONTACTS': '移除玩家',
  'TESTER.MANAGE.TEST.LIST.REMOVE.CONTACTS.TIPS1': '仅待邀请且未封禁玩家可移除',
  'TESTER.MANAGE.TEST.LIST.CONFIRM.REMOVE': '确认移除',
  'TESTER.MANAGE.TEST.LIST.DELETING.TIP': '正在移除中...',
  'TESTER.MANAGE.TEST.LIST.DELETING.PROGRESS': '正在移除中....',
  // 展示对应的游戏的头像和名称
  'TESTER.MANAGE.TEST.LIST.PLATFORM.SOURCE': '连接来源：',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.NOT.LINKED': '无',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.NOT.LINKED.TIPS': '暂未关联{platform}游戏',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.STEAM.LINKED':
    '通过 Steam API 追踪游戏时长和愿望单状态',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.LINKED':
    '分析实时聊天记录中的情感倾向和贡献度',
  // 多频道展示（AI 分析配置多个 Discord 频道时）
  // 触发器：右上角服务器名称后的频道入口文案
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.MULTIPLE.CHANNELS':
    '数据源频道 ({count})',
  // hover 浮层标题：分析范围
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.ANALYZE.SCOPE.TITLE': '分析范围：',
  // hover 浮层标题描述：基于实时聊天日志分析出的情感分与贡献度
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.ANALYZE.SCOPE.DESC':
    '基于实时聊天日志分析出的情感分与贡献度。',
  // hover 浮层列表副标题：数据源频道 (N)：
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.SOURCE.CHANNELS':
    '数据源频道 ({count})：',
  // Steam ID
  'TESTER.MANAGE.TEST.LIST.TABLE.STEAM.ACCOUNT.ID': 'Steam ID',
  // 添加联系人
  'TESTER.MANAGE.TEST.LIST.AddCONTACT': '添加测试玩家',
  'TESTER.MANAGE.TEST.LIST.DIALOG.HEADER.ADD.TESTER': '添加测试玩家',
  'TESTER.MANAGE.TEST.LIST.DIALOG':
    '所选标签下的联系人会同步至测试玩家列表。新添加到该标签的联系人需重新添加标签。',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECT.PLACEHOLDER': '选择标签',
  // 删除联系人 二次弹窗
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.TITLE': '确定要移除测试玩家吗？',
  // 删除联系人 二次弹窗内容文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONTENT':
    '移除后，所有已选联系人将不再同步至该列表中。',
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.TIP':
    '<span class="color-666">将</span><b class="color-333 font-weight-700">移除</b> <b class="color-333 font-weight-700 font-size-32" style="margin-bottom: -4px; display: inline-block; vertical-align: bottom;">{num}</b> <span class="color-666">位</span>',
  // 删除联系人 二次弹窗内容文本-确认文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONFIRM.BTN.TEXT': '确定',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECTED.PLAYERS':
    '已选择: <b>{CONTACTS}个测试玩家<b>',
  'TESTER.MANAGE.TEST.LIST.DIALOG.EMAIL.SUBSCRIBERS': '已订阅邮箱数',
  'TESTER.MANAGE.TEST.LIST.DIALOG.EMAIL.CONTACTS': '邮箱总数',
  // 同步联系人 message
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT': '已添加{CONTACT}个联系人',
  'TESTER.MANAGE.TEST.LIST.SYNC.ZERO.CONTACT': '该标签下暂无已订阅联系人可添加',
  // 同步联系人百分比
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.PROGRESS': '数据读取',
  // 添加 测试人员按钮 tooltip信息-别人在同步
  'TESTER.MANAGE.TEST.LIST.DISABLED.TOOLTIP.ADDING': '联系人添加中....',
  // 轮询 接口 数据被删除 返回列表页 文案
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.DATA.DELETE.TITLE': '测试被删除',
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.DATA.DELETE': '请返回列表页',
  // 确认邀请按钮文案
  'TESTER.MANAGE.TEST.LIST.CONFIRM.INVITATION': '确认邀请',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION': '确认邀请选中的测试玩家？',
  // 'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS.ON.THE.WAITLIST':
  //   '已选择',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS': '待邀请',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT':
    ' 确认后，这些玩家将正式进入邀请旅程;',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TIPS':
    '系统仅会邀请处于“Waiting”状态且已订阅邮件的玩家。',
  // 旅程详情跳转
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT.JOURNEY.DETAILS':
    '查看旅程详情',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT.TAGS':
    '联系人受邀后自动绑定此处添加的标签',
  // 表头相关
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIPTION.STATUS': '订阅状态',
  'TESTER.MANAGE.TEST.LIST.TABLE.REGION': '地区',
  'TESTER.MANAGE.TEST.LIST.TABLE.LANGUAGE': '语言',
  'TESTER.MANAGE.TEST.LIST.TABLE.TAGS': '标签',
  'TESTER.MANAGE.TEST.LIST.TABLE.AUTHORIZATION.PLATFORM': '作者设备',
  'TESTER.MANAGE.TEST.LIST.TABLE.JOINED.LIST': '加入列表时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.INVITED.TIME': '受邀时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONBOARDING.TIME': '接受邀请日期',
  'TESTER.MANAGE.TEST.LIST.TABLE.INVITED.FRIENDS.COUNT': '邀请好友数',
  'TESTER.MANAGE.TEST.LIST.TABLE.START.TIME': '开始时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.END.TIME': '结束时间',
  'TESTER.MANAGE.TEST.LIST.TABLE.STATUS': '状态',
  'TESTER.MANAGE.TEST.LIST.TABLE.EMAIL': '邮箱',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIBED': '已订阅',
  'TESTER.MANAGE.TEST.LIST.TABLE.PENDING': '待定',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNSUBSCRIBED': '未订阅',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNBOUND': '未绑定',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNKNOWN': '未知',
  'TESTER.MANAGE.TEST.LIST.TABLE.DRAFT': '草稿',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING': '进行中',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING.JOURNEY.ERROR': '正在进行的行程错误',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUSPENDED': '暂停',
  'TESTER.MANAGE.TEST.LIST.INVITATION.COMPLETE': '邀请已发送',
  'TESTER.MANAGE.TEST.LIST.INVITATION.FAILED': '邀请发送失败',
  'TESTER.MANAGE.TEST.LIST.DELETE': '已成功移除{deleteTesterNums}个测试玩家',
  'TESTER.MANAGE.TEST.LIST.EDIT.INFO': '编辑成功',
  'TESTER.MANAGE.TEST.LIST.IMPORT.CONTACT': '导入成功',
  'TESTER.MANAGE.TEST.LIST.CREATED.INFO': '创建成功',
  'TESTER.MANAGE.TEST.LIST.PLAYER ENTERED INVITATION JOURNEY':
    '玩家已进入邀请旅程',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY': 'Steam key',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.NOT.SENT': '/',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.FETCHING': '获取中',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.NOT.EXCHANGED': '未兑换',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.EXCHANGED': '已兑换',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.LAST.UPDATED.AT': '上次更新 {updateTime}',
  // 引导内容
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TITLE': '测试列表使用指南',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP1.TITLE':
    '注册与邀请流程配置（运营支持）',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP1':
    '<span class="guide-content"><span class="guide-content-text"><b>个性化定制：</b>支持在标准流程基础上，对页面文案和视觉样式进行深度自定义。请联系<a  href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> 协助完成配置。</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>平台授权接入：</b>若需获取玩家在 Steam 或 Discord 平台的认证信息，需预先提供对应平台的授权账号（配置细则可参考 <a href="https://docs.smartlink.intlgame.com/zh/function-guide/manage-playtesthub-configuration/" target="_blank">Playtest 平台配置手册</a>）。</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>数据采集与标识：</b>支持通过内置问卷收集玩家个人信息，并配置自定义标签（Tags）以精准区分玩家来源。</span></span>',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP2.TITLE': '玩家资源导入',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP2':
    '<span class="guide-content"><span class="guide-content-text"><b>全渠道自动同步：</b>您可以将注册链接部署于官网等外部渠道，通过该链接完成注册的玩家将自动同步至“玩家测试列表”及“联系人列表”。</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>标签化批量导入：</b>在测试列表页面，支持点击“添加测试玩家”并通过标签筛选进行批量导入。</span></span>',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP3.TITLE': '测试旅程配置（前置准备）',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP3':
    '<span class="guide-content"><span class="guide-content-text"><b>旅程配置：</b>玩家受邀后将按预设节点自动流转。请务必在发起邀请前，完成旅程的配置与发布。</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>配置入口：</b>在玩家测试列表内，点击“编辑”按钮即可进入可视化配置界面。</span></span>',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP4.TITLE': '邀请玩家',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP4':
    '<span class="guide-content"><span class="guide-content-text"><b>前置条件：</b>发起邀请前，请确保关联的测试旅程已配置就绪。</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>受邀流转逻辑：</b></span></span><br/><span class="guide-content guide-content-child"><span class="guide-content-text guide-content-child-text"><span class="color-333">未注册玩家：</span>收到邀请邮件后，需先完成注册流程，随后即可接受邀请。</span></span><br/><span class="guide-content guide-content-child"><span class="guide-content-text guide-content-child-text"><span class="color-333">已注册玩家：</span>可直接接受邀请。</span></span>',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.COLUMN': '列',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.COLUMN.SELECT': '选中要展示的列',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.APPLY': '应用',
  'TESTER.MANAGE.TEST.LIST.BAN.TITLE': '封禁',
  'TESTER.MANAGE.TEST.LIST.BAN.TITLE.TIPS1': '单次封禁最多选中一人',
  'TESTER.MANAGE.CONFIG.EDIT.NAME': 'Edit name & description',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.LABEL':
    '1、Includes contacts who match all selected tags.',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.PLACEHOLDER':
    '标签下的联系人会自动加入到测试列表',
  'TESTER.MANAGE.CONFIG.TEST': '2、Test configure',
  'TESTER.MANAGE.CONFIGURED': '已配置',
  'TESTER.MANAGE.NOT.CONFIGURED': '未配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.TITLE': '受邀流程配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.DESC':
    '此链接提供协议签署、绑定discord 或 steam的玩家受邀流程，请联系 XXXX@XXXX.com完成测试链接配置。',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.LINK.COPY': '复制链接',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.TITLE': '邀请邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.DESC':
    '请将第一步配置好的受邀流程链接粘贴到邮件模板中。<br/>联系人通过邀请邮件，接受测试邀请。',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.SENTING.TIPS':
    'The email is being sent; settings cannot be changed',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.TITLE': '资源码邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.DESC':
    '联系人通过邀请邮件，接受测试邀请。<br/>联系人接受邀请，完成邀请流程后，系统会自动为联系人发送资源码邮件。',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.NUM': '资源码数量：{num}',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.UPLOAD': '上传',
  'TESTER.MANAGE.CONFIG.LEAVE.TITLE':
    'Do you want to save the changes you have made?',
  'TESTER.MANAGE.CONFIG.LEAVE.DESC':
    'Here is subtitle description description description description',
  'TESTER.MANAGE.CONFIG.SAVE.TITLE': 'Confirm to save the configuration?',
  'TESTER.MANAGE.CONFIG.SAVE.DESC':
    '<p>Confirm and save the configuration; contacts within the tags will be automatically synchronized to the configuration management page.</p><p style="margin-top: 16px;">You can enter the configuration management page to send invitations to contacts</p>',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TESTER': 'Save and return test list',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TEST': 'Save and enter test management',

  /** 删除弹窗 */
  'TESTER.MANAGE.DELETE.TITLE': '确认删除测试玩家列表？',
  'TESTER.MANAGE.DELETE.DESC': '删除{tester}后，测试玩家列表不可恢复。',

  'TEST.MANAGE.AI.ANALYTICS.DISABLED.TOOLTIP':
    '请联系 <a href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> 完成Discord配置。',
  'TEST.MANAGE.AI.ANALYTICS.NOT.CONFIGURED.TOOLTIP':
    '配置尚未完成，请联系 <a href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> 协助开启。',
  'TESTER.MANAGE.BIND': '已绑定',
  'TESTER.MANAGE.UNBIND': '未绑定',
  // 时间线 - 封禁/解封
  'TESTER.MANAGE.TIMELINE.BAN.TESTER':
    '<b style="color:#000">玩家测试中心</b>-测试名称{testerName}：联系人被 {createdBy} 封禁',
  'TESTER.MANAGE.TIMELINE.BAN.DISCORD':
    'Discord 服务器 {discordServerName}：已封禁此用户',
  'TESTER.MANAGE.TIMELINE.UNBAN.TESTER':
    '<b style="color:#000">玩家测试中心</b>-测试名称{testerName}：联系人被 {createdBy} 解除封禁',
  'TESTER.MANAGE.TIMELINE.UNBAN.DISCORD':
    'Discord 服务器 {discordServerName}：解除封禁此用户',

  // 二次确认邮件
  'TESTER.MANAGE.OPTIN.STRATEGY.SET': '双重确认设置',
  'TESTER.MANAGE.OPTIN.STRATEGY.NAME': '双重确认设置-{testerManageName}',
  'TESTER.MANAGE.OPTIN.STRATEGY.DESC':
    '设置联系人注册测试后是否发送二次确认邮件',
  'TESTER.MANAGE.OPTIN.STRATEGY.METHOD.SINGLE.DESC':
    '首次通过测试加入系统的联系人，订阅状态可直接更新为“已订阅”无需发送二次确认邮件。此方式能最大化地提升列表增长速度。',
  'TESTER.MANAGE.OPTIN.STRATEGY.METHOD.DOUBLE.PARTICULAR.DESC1':
    '首次通过测试加入系统的联系人需要通过确认邮件进行验证后，才会被正式订阅。在确认前，其订阅状态为待确认（Pending）。此模式会为特定国家/地区的用户自动启用，以帮助您符合当地法律要求，同时简化其他地区用户的订间流程。',
  'TESTER.MANAGE.OPTIN.STRATEGY.METHOD.DOUBLE.ALL.DESC1':
    '无论来自任何地区，首次通过测试加入系统的联系人都需要通过确认邮件进行验证。在确认前，其订阅状态为"待确认（Pending)”。此方式能确保最高质量的联系人列表，并明确地获得用户的订阅意愿。',
  'TESTER.MANAGE.OPTIN.SAVE': '保存配置',

  // 报表分类
  'TESTER.MANAGE.REPORT.CATEGORY': '游戏测试列表',
};
